import { getErrorMessage } from '../../../lib/utils';

export default function (app) {
  return {
    state: {
      submission: {},
    },
    getters: {

    },
    actions: {
      async getSubmission({ state, commit, }) {
        const licenseKey = state.licenseKey;
        if (!licenseKey) {
          throw new Error('No license Key supplied');
        }

        commit('setError', {});
        commit('setLoading', true);

        try {
          const submission = await app.service('submissions').get(licenseKey);

          const { age, completed, createdAt, gender, id, name, updatedAt, answers, reportType, } = submission;
          commit('setSubmission', { age, completed, createdAt, gender, id, licenseKey, name, updatedAt, reportType, });

          if (answers && answers.length > 0) {
            answers.map(({ questionId, value, }) => commit('setAnswer', { questionId, value, }));
          }

          commit('setLoading', false);

          return submission;
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          commit('setLoading', false);

          throw e;
        }
      },

      async createSubmission({ commit, }, data) {
        commit('setError', {});
        commit('setLoading', true);

        try {
          const submission = await app.service('submissions').create(data);

          const { age, completed, createdAt, gender, id, name, updatedAt, licenseKey, } = submission;
          commit('setSubmission', { age, completed, createdAt, gender, id, licenseKey, name, updatedAt, });
          commit('setAnswers', {});

          commit('setLoading', false);

          return submission;
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          commit('setLoading', false);

          throw e;
        }
      },

      async completeSubmission({ state, dispatch, commit, }) {
        commit('setError', {});
        commit('setLoading', true);

        try {
          await app.service('submissions').patch(state.licenseKey, {
            completed: true,
          });

          await dispatch('getSubmission');

          commit('setLoading', false);
        } catch (e) {
          commit('setError', { show: true, message: getErrorMessage(e), });
          commit('setLoading', false);

          throw e;
        }
      },
    },
    mutations: {
      setSubmission: (state, submission) => state.submission = submission,
    },
  };
}
